import { render, staticRenderFns } from "./titulo2.vue?vue&type=template&id=43f53bdf&scoped=true"
import script from "./titulo2.vue?vue&type=script&lang=js"
export * from "./titulo2.vue?vue&type=script&lang=js"
import style0 from "./titulo2.vue?vue&type=style&index=0&id=43f53bdf&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f53bdf",
  null
  
)

export default component.exports